import { Injectable } from '@angular/core';
import { ExternalTaskType } from '@wdx/portal/api-models';

@Injectable({
    providedIn: 'root',
})
export class ChecklistRoutingHelperService {
    generateTaskRoute(
        taskType?: ExternalTaskType,
        taskId?: string | null,
        checklistPrefix = true,
    ): string[] {
        switch (taskType) {
            case ExternalTaskType.Form:
                return this.createChecklistRoute(
                    'form',
                    checklistPrefix,
                    taskId,
                );
            case ExternalTaskType.DocumentRequirement:
                return this.createChecklistRoute(
                    'document-upload',
                    checklistPrefix,
                    taskId,
                );
            case ExternalTaskType.SignatureRequirement:
                return this.createChecklistRoute(
                    'signature',
                    checklistPrefix,
                    taskId,
                );
            case ExternalTaskType.IdentityVerification:
                return this.createChecklistRoute(
                    'identity-and-verification',
                    checklistPrefix,
                    taskId,
                );
            case ExternalTaskType.Bespoke:
                return this.createChecklistRoute(
                    'bespoke',
                    checklistPrefix,
                    taskId,
                );
            default:
                return ['', 'checklist'];
        }
    }

    private createChecklistRoute(
        path: string,
        checklistPrefix: boolean,
        id?: string | null,
    ): string[] {
        const prefix = checklistPrefix ? ['', 'checklist'] : ['.'];
        return [...prefix, ...([path, id].filter(Boolean) as string[])];
    }
}
